import { createAsyncThunk } from '@reduxjs/toolkit';

import { OrdersService } from 'wanderu-service-wapi';

import { parseApiError } from './errors';
import { selectOrderId } from './ordersSlice';

import type { OrdersRootState } from './listeners';

export const acceptInsurance = createAsyncThunk(
    'insurance/accept',
    async (_, { getState, rejectWithValue }) => {
        const orderId = selectOrderId(getState() as OrdersRootState);
        if (!orderId) {
            return rejectWithValue('No orderId in state');
        }
        try {
            await OrdersService.post(
                `public/orders/order/${orderId}/insurance`,
                {},
                {},
            );
            return undefined;
        } catch (error: unknown) {
            return rejectWithValue(parseApiError(error, {
                expectedCategories: [],
                knownCodes: new Set<string>(),
            }));
        }
    },
);

export const declineInsurance = createAsyncThunk(
    'insurance/decline',
    async (_, { getState, rejectWithValue }) => {
        const orderId = selectOrderId(getState() as OrdersRootState);
        if (!orderId) {
            return rejectWithValue('No orderId in state');
        }
        try {
            await OrdersService.delete(
                `public/orders/order/${orderId}/insurance`,
                {},
                {},
            );
            return undefined;
        } catch (error: unknown) {
            return rejectWithValue(parseApiError(error, {
                expectedCategories: [],
                knownCodes: new Set<string>(),
            }));
        }
    },
);
